import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import KioskSettingsLanguageInputs from "./KioskSettingsLanguageInputs";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
}

const KioskSettingsTextsCard = ({ form }: Props) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();

	return (
		<fieldset className="form-group">
			<h6>{t("modules.venue_settings.field.texts.title")}</h6>
			<div className="d-flex flex-column gap-3">
				{organization.languages.map((language) => (
					<KioskSettingsLanguageInputs key={language} form={form} language={language} />
				))}
			</div>
		</fieldset>
	);
};

export default KioskSettingsTextsCard;
